module.exports = __webpack_public_path__ + "static/img/profile-background.d740ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/profile-background.png
// module id = IgIw
// module chunks = 0